module.exports = __webpack_public_path__ + "static/dog-training-treat-5499cc02b9e5137b2e04c3e1aa051bef.jpg";